import { render, staticRenderFns } from "./CultureDesignMaterialBorrowAudit.vue?vue&type=template&id=ed06f29c&scoped=true&"
import script from "./CultureDesignMaterialBorrowAudit.vue?vue&type=script&lang=js&"
export * from "./CultureDesignMaterialBorrowAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed06f29c",
  null
  
)

export default component.exports